import { Box, Group, Select, TextInput } from "@mantine/core"
import { MagnifyingGlassIcon } from "@phosphor-icons/react"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

export type HandoverQuickFilter = "ALL" | "READY" | "IN_PROGRESS" | "FAILED" | "PICKUP"

interface Props {
  stage: string
  onStageChange: (next: string) => void
  stageOptions: { value: string; label: string }[]
  quick: HandoverQuickFilter
  onQuickChange: (next: HandoverQuickFilter) => void
  counts: {
    all: number
    ready: number
    inProgress: number
    failed: number
    pickup: number
  }
  search: string
  onSearchChange: (value: string) => void
  /** Right-aligned primary action («Хүлээлцэл үүсгэх»). */
  action?: ReactNode
}

/** Labelled filters + create action in one row (canvas Ord_DeliveryHub, hand tab). */
export function HandoverFiltersToolbar({
  stage,
  onStageChange,
  stageOptions,
  quick,
  onQuickChange,
  counts,
  search,
  onSearchChange,
  action,
}: Props) {
  const { t } = useTranslation("delivery")
  const quickData = [
    { value: "ALL", label: `${t("custody.filters.all")} (${counts.all})` },
    { value: "READY", label: `${t("custody.filters.ready")} (${counts.ready})` },
    { value: "IN_PROGRESS", label: `${t("custody.filters.inProgress")} (${counts.inProgress})` },
    { value: "FAILED", label: `${t("custody.filters.failed")} (${counts.failed})` },
    { value: "PICKUP", label: `${t("custody.filters.pickup")} (${counts.pickup})` },
  ]

  return (
    <Group gap="md" wrap="wrap" align="flex-end">
      <Select
        label={t("custody.filters.status")}
        data={stageOptions}
        value={stage}
        onChange={(v) => v && onStageChange(v)}
        w={200}
        allowDeselect={false}
      />
      <Select
        label={t("custody.filters.progressState")}
        data={quickData}
        value={quick}
        onChange={(v) => onQuickChange((v as HandoverQuickFilter) ?? "ALL")}
        w={220}
        allowDeselect={false}
      />
      <TextInput
        label={t("custody.filters.searchLabel")}
        placeholder={t("custody.filters.searchPlaceholder")}
        value={search}
        onChange={(e) => onSearchChange(e.currentTarget.value)}
        leftSection={<MagnifyingGlassIcon size={16} />}
        w={300}
      />
      <Box flex={1} />
      {action}
    </Group>
  )
}
